import React, { useState } from 'react';
const faqs = [{
  q: 'Est-ce adapté aux débutants ?',
  a: 'Oui. Le système inclut des progressions simples et professionnelles pour tous les niveaux.'
}, {
  q: "Puis-je l'utiliser en small group ?",
  a: 'Oui. Les structures small group sont incluses et conçues pour les classes de groupe.'
}, {
  q: 'Les bonus sont-ils inclus ?',
  a: "Oui. Vous recevez immédiatement l'accès à l'ensemble du système et aux 6 bonus."
}, {
  q: 'Fonctionne-t-il sur tablette et smartphone ?',
  a: 'Oui. Le système est compatible avec tous les appareils.'
}, {
  q: 'Est-ce un paiement unique ?',
  a: "Oui. Aucun abonnement, c'est un paiement unique avec accès à vie."
}, {
  q: 'Y a-t-il une garantie ?',
  a: 'Oui. Vous bénéficiez de 7 jours de garantie totale satisfait ou remboursé.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-bg-dark py-24 px-4 border-t border-border-light" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <h2 className="font-display text-3xl sm:text-5xl font-bold text-white text-center mb-12 tracking-tight uppercase" data-id="element-128">
          Questions Fréquentes
        </h2>

        <div className="space-y-3 mb-16" data-id="element-129">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-sm overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(242,92,37,0.15)]' : 'border-border-light hover:border-border-strong'}`} data-id="element-130">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-131">
                  <span className={`font-display font-bold text-base sm:text-lg uppercase tracking-wide transition-colors ${isOpen ? 'text-primary' : 'text-white'}`} data-id="element-132">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 font-bold ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-133">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-134">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-135">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-136">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-137"></div>
          <a href="#pricing" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Functional Clé en Main — Système Complet',
              content_type: 'product',
              value: 24,
              currency: 'EUR'
            });
          }
        }} className="relative btn-primary-pulse bg-cta-green font-display font-bold text-base sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-sm hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(22,163,74,0.3)] border border-white/10 uppercase tracking-wide" data-id="element-138">
            🚀 OUI ! JE VEUX ARRÊTER D'IMPROVISER MES CLASSES
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2 mt-3 uppercase tracking-wider flex-wrap" data-id="element-139">
            <span data-id="element-140">⚡ Accès Immédiat</span>
            <span data-id="element-141">•</span>
            <span data-id="element-142">🛡️ Garantie 7 Jours</span>
            <span data-id="element-143">•</span>
            <span data-id="element-144">💳 Paiement Sécurisé</span>
          </p>
        </div>
      </div>
    </section>;
}